import { api, authHeader } from "../configs/axiosConfigs";

const resolveBaseUrl = (source) =>
  source === "Management"
    ? "/SLN/Management/OperationalProcessesReport"
    : "/SLN/SolarentOperator/OperationalProcessesReport";

const OperationalProcessesReportApi = {
  getFilterData: async (source = "Management") => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/GetFilterData`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  search: async (source = "Management", searchParams) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/Search`,
      method: "POST",
      headers: authHeader(),
      data: searchParams,
    });
    return response.data;
  },
};

export default OperationalProcessesReportApi;
